import type { AGGError } from '@jira/platform__graphql-relay-errors/src/index.tsx';

/**
 * Error class for GraphQL responses that contain errors.
 *
 * Provides backward compatibility with Apollo's error shape where consumers
 * check `error.graphQLErrors` to inspect individual GraphQL errors
 * (e.g. checking `extensions.statusCode` for 401/403/404).
 */
export class GraphQLResponseError extends Error {
	readonly graphQLErrors: AGGError[];

	constructor(message: string, graphQLErrors: AGGError[]) {
		super(message);
		this.name = 'GraphQLResponseError';
		this.graphQLErrors = graphQLErrors;
	}
}
